// Handler to close the date selector popup
export const dateSelectorPopUpClose = (setDateSelectorPopUpAnchorEl) => {
    setDateSelectorPopUpAnchorEl(null);
};
